import { render, staticRenderFns } from "./assistant-client-candidates.vue?vue&type=template&id=4446991a&scoped=true"
import script from "./assistant-client-candidates.vue?vue&type=script&lang=js"
export * from "./assistant-client-candidates.vue?vue&type=script&lang=js"
import style0 from "./assistant-client-candidates.vue?vue&type=style&index=0&id=4446991a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446991a",
  null
  
)

export default component.exports